import api from '../index';

const vettingOptOutUpdaters = {
  optOut: async (token: string) => {
    return api.post(`/profiles/preferences/opt-out`, {token});
  },
};

export default vettingOptOutUpdaters;
